import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import ThankYou from "./pages/ThankYou";
import InfissiPage from "./pages/InfissiPage";
import InfissiSubcategoryPage from "./pages/InfissiSubcategoryPage";
import OutdoorPage from "./pages/OutdoorPage";
import OutdoorSubcategoryPage from "./pages/OutdoorSubcategoryPage";
import FerroPage from "./pages/FerroPage";
import FerroSubcategoryPage from "./pages/FerroSubcategoryPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/grazie" element={<ThankYou />} />
          <Route path="/infissi" element={<InfissiPage />} />
          <Route path="/infissi/:slug" element={<InfissiSubcategoryPage />} />
          <Route path="/outdoor" element={<OutdoorPage />} />
          <Route path="/outdoor/:slug" element={<OutdoorSubcategoryPage />} />
          <Route path="/ferro" element={<FerroPage />} />
          <Route path="/ferro/:slug" element={<FerroSubcategoryPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
